export const AUTH_ACTION_TYPES = {
  LOGIN: 'auth/LOGIN',
  LOGOUT: 'auth/LOGOUT',
  SET_AUTH_INFO: 'auth/SET_AUTH_INFO',
  GET_CURRENT: 'auth/GET_CURRENT',
};

export function login(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: AUTH_ACTION_TYPES.LOGIN,
        payload,
        resolve,
        reject,
      });
    });
  };
}

export function logout() {
  return {
    type: AUTH_ACTION_TYPES.LOGOUT,
  };
}

export function setAuthInfo(payload) {
  return {
    type: AUTH_ACTION_TYPES.SET_AUTH_INFO,
    payload,
  };
}

export function getCurrent() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: AUTH_ACTION_TYPES.GET_CURRENT,
        resolve,
        reject,
      });
    });
  };
}
